/* Klaviyo public client subscription API; never use a private API key here.
   https://developers.klaviyo.com/en/reference/create_client_subscription */
if (!customElements.get('bigdrop-subscription')) {
  customElements.define('bigdrop-subscription', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const button = form.querySelector('button');
      const input = form.querySelector('input');
      const status = this.querySelector('[role="status"]');
      const site = this.dataset.siteId.trim();
      const list = this.dataset.listId.trim();
      if (!/^[a-zA-Z0-9]+$/.test(site) || !/^[a-zA-Z0-9]+$/.test(list)) return;
      button.disabled = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (button.disabled || !form.reportValidity()) return;
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        status.textContent = 'Submitting�';
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(site), {
            method: 'POST',
            headers: {'Content-Type':'application/vnd.api+json', Accept:'application/vnd.api+json', revision:'2026-07-15'},
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Big Drop V2 homepage newsletter',
                  profile: { data: { type: 'profile', attributes: {
                    email: input.value.trim(),
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  } } }
                },
                relationships: { list: { data: { type: 'list', id: list } } }
              }
            }),
            signal: AbortSignal.timeout(15000)
          });
          if (response.status !== 202) throw new Error('Subscription not accepted');
          status.textContent = this.dataset.success;
          form.reset();
          form.hidden = true;
        } catch {
          status.textContent = 'We couldn�t submit your subscription. Please try again.';
          button.disabled = false;
        } finally {
          form.removeAttribute('aria-busy');
        }
      });
    }
  });
}
